enum MediaTargetType {
  // backend types
  JOB = 6,
  DOSSIER = 7,

  // frontend types
  DIAGNOSTIC = 101,

  /* deprecated types
  OBSERVATION = 2,
  TIRE = 4,
  DOSSIER = 5,
  ATTACHMENT = 7,
  */
}

export default MediaTargetType;